import _ from 'lodash'
import QRCode from 'qrcode'
import receiptView from '@/components/custom/print/pos/Receipt.vue'
import { mapGetters, mapActions } from 'vuex'
import { POS_PAYMENT_METHOD } from '@/helpers/enum'

export default {
  components: {
    receiptView,
  },
  data () {
    return {
      POS_PAYMENT_METHOD: POS_PAYMENT_METHOD,
      orders: [],
      totalPrice: [],
      dateTime: '',
      receiptInfo: {},
      printing: {
        currentPrinted: 0,
      },
      qrcodeReceiptDataUrl: '',
      isSendingEmail: false,
      email: '',
    }
  },
  computed: {
    ...mapGetters({
      pos: 'getPos',
      products: 'getPosProducts',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
      getShopInfo: 'getShopInfo',
      getReceiptInfo: 'getReceiptInfo',
      posSettings: 'getPosSetting',
      posSession: 'getPosSession',
      queues: 'getPosQueues',
      getLang: 'getLang',
    }),
    autoPrint () {
      return this.posSettings.print.auto
    },
    reprintCount() {
      const copies = this.posSettings.print.copies == null
        ? 1
        : this.posSettings.print.copies
      return copies - 1
    },
    receiptInfoProps () {
      return {
        shopLogo: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_logo) {
            return this.getShopInfo.logo.thumbnail
          }
        })(),
        shopName: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_name) {
            return this.getShopInfo.shop_name
          }
        })(),
        shopAddress: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_address) {
            return this.getShopInfo.info.location.address
          }
        })(),
        shopTaxId: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_tax_id) {
            return this.getShopInfo.info.vat.taxpayer_no
          }
        })(),
        shopTaxTitle: this.getShopInfo.settings.apps.pos.receipt.is_show_tax_title,
        shopTel: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.is_show_tel) {
            const contact = this.getShopInfo.contacts.find((item) => item.platform === 'tel')
            return contact ? contact.source : ''
          }
        })(),
        orders: this.orders,
        totalPrice: this.totalPrice,
        receiptInfo: this.receiptInfo,
        textFooter: (() => {
          if (this.getShopInfo.settings.apps.pos.receipt.text_footer.is_active) {
            return this.getShopInfo.settings.apps.pos.receipt.text_footer.value
          }
        })(),
        fontSize: this.getShopInfo.settings.apps.pos.receipt.font_size,
        dateTime: this.dateTime,
      }
    },
    use_queue () {
      return this.posSettings.queue.is_active
    },
    showQrCodeReceipt() {
      return this.qrcodeReceiptDataUrl
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'clearPosOrderBy',
      'clearPosSelectedCustomerId',
      'clearPosSelectedDiningName',
      'clearPosSelectedTable',
      'setPosNextQueueNumber',
      'addPosNextQueue',
      'setPosSelectedQueue',
      'sentReceiptEmail',
    ]),
    setUI () {
      var mainHeight = $('.main').outerHeight()
      var sectionHeight = $('.section').outerHeight()

      $('.section').css({
        'top': (mainHeight - sectionHeight - 25) / 2 + 'px',
      })
    },
    handleWindowResize (event) {
      var that = this
      setTimeout(() => {
        // set ui
        that.setUI()
      }, 10)
    },
    onClickDone () {
      this.setPosSection('choose-product')
    },
    onclickPrint () {
      $('.receipt-template').printThis({
        afterPrint: this.handleAfterPrint,
      })
    },
    handleKeyup (e) {
      let lastSecIsBarcode = this.$store.state.pos.pos.lastSecIsBarcode
      if (e.key == 'Enter' && !lastSecIsBarcode) {
        this.onClickDone()
      }
    },
    handleAfterPrint() {
      this.printing.currentPrinted++
      if (this.reprintCount > 0 && this.printing.currentPrinted <= this.reprintCount) {
        this.onclickPrint()
      }
    },
    async setQRCodeDataUrl() {
      if (!this.qrcodeReceiptDataUrl) {
        const branchName = `${this.$store.state.posBranch.branch.name}`.replaceAll(' ', '_')
        const fileName = `${this.$t('message.receipt')}_${branchName}_${this.moment().format('Y-MM-DD')}`
        const renderReceiptUrl = `${this.project.config.web.api}pos/bill/${this.getReceiptInfo.posbi_id}/${fileName}?lang=${this.getLang}`
        const dataUrl = await QRCode.toDataURL(renderReceiptUrl)
        this.qrcodeReceiptDataUrl = dataUrl

        const img = new Image()
        img.src = dataUrl
        img.onload = () => {
          this.setUI()
        }
      } else {
        this.qrcodeReceiptDataUrl = ''
        this.$nextTick(() => {
          this.setUI()
        })
      }
    },
    async onclickSentEmail() {
      if (!this.validateEmail(this.email)) {
        this.notify(this.$vs, {
          text: this.$t('message.emailisinvalid'),
          color: 'warning',
          icon: 'warning',
        })
      } else {
        this.isSendingEmail = true
        const response = await this.sentReceiptEmail({
          posbiId: this.getReceiptInfo.posbi_id,
          data: {
            lang: this.getLang,
            email: this.email,
            app_id: 1,
            module_id: 1,
          },
        })
        if (response.success) {
          this.notify(this.$vs, {
            text: this.$t('message.emailsentsuccess', { email: this.email }),
            color: 'success',
            icon: 'email',
          })
        }
        this.isSendingEmail = false
        this.showFinish(this.$Progress)
      }
    },
  },
  created: function () {
    const currentQueueNumber = _.cloneDeep(this.queue_number)
    const currentTableNumber = _.cloneDeep(this.table_number)

    // set data
    this.orders = _.cloneDeep(this.getPosOrdersById({
      queue_number: this.queue_number,
      table_number: this.table_number,
    }))
    this.totalPrice = _.cloneDeep(this.getPosTotalPriceById({
      queue_number: this.queue_number,
      table_number: this.table_number,
    }, this.mixin))
    this.receiptInfo = _.cloneDeep(this.getReceiptInfo)
    this.receiptInfo['ps_code'] = this.posSession.ps_code
    this.dateTime = this.moment(this.receiptInfo.created_at).format('H:mm')

    // clear state
    this.clearPosOrderBy({
      queue_number: this.queue_number,
      table_number: this.table_number,
      isDeleteQueue: true,
    })
    this.clearPosSelectedTable()
    this.clearPosSelectedCustomerId({
      queue_number: currentQueueNumber,
      table_number: currentTableNumber,
    })
    this.clearPosSelectedDiningName({
      queue_number: currentQueueNumber,
      table_number: currentTableNumber,
    })

    if (this.use_queue) {
      this.setPosNextQueueNumber(currentQueueNumber)

      if (this.queues.length === 0) {
        this.addPosNextQueue()
      }
    }

    if (this.posSettings.qrcode_receipt.auto === true) {
      this.setQRCodeDataUrl()
    }
  },
  mounted: function () {
    // auto print receipt
    if (this.autoPrint) {
      this.onclickPrint()
    }
    // set ui
    this.setUI()
    // event resize
    window.addEventListener('resize', this.handleWindowResize)
    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/paymentComplate.js